/**
 * Zopup - Product Catalogue API
 * Zopup - Product Catalogue API
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

// Third party library imports
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

// Zopup library imports
import { 
    BooleanWebApiResponse,
    UOMCreateCommand,
    UOMDtoListWebApiResponse,
    UOMDtoWebApiResponse,
    UOMUpdateCommand,
} from '@zopup/zop-types';

// Internal project imports
import { BaseService } from '../api.base.service';
import { Configuration } from '../configuration';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { PRODUCT_CATALOGUE_API_BASE_PATH } from '../api-tokens';

@Injectable({
    providedIn: 'root'
})
export class UOMService extends BaseService {

    constructor(
        protected httpClient: HttpClient,
        @Inject(PRODUCT_CATALOGUE_API_BASE_PATH) private apiBasePath: string
    ) {
        super();
        this.basePath = this.apiBasePath;
        this.configuration.basePath = this.basePath;
    }

    /**
     * 
     * 
     * @param isActive 
     * @param orderBy 
     * @param isOrderByDescending 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uOMGet(isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<UOMDtoListWebApiResponse>;
    public uOMGet(isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UOMDtoListWebApiResponse>>;
    public uOMGet(isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UOMDtoListWebApiResponse>>;
    public uOMGet(isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isActive !== undefined && isActive !== null) {
            queryParameters = queryParameters.set('IsActive', <any>isActive);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', <any>element);
            })
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', <any>isOrderByDescending);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UOMDtoListWebApiResponse>('get',`${this.basePath}/UOM`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uOMIdDelete(id: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public uOMIdDelete(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public uOMIdDelete(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public uOMIdDelete(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling uOMIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BooleanWebApiResponse>('delete',`${this.basePath}/UOM/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uOMIdGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<UOMDtoWebApiResponse>;
    public uOMIdGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UOMDtoWebApiResponse>>;
    public uOMIdGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UOMDtoWebApiResponse>>;
    public uOMIdGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling uOMIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UOMDtoWebApiResponse>('get',`${this.basePath}/UOM/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param xRequestId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uOMPost(body?: UOMCreateCommand, xRequestId?: string, observe?: 'body', reportProgress?: boolean): Observable<UOMDtoWebApiResponse>;
    public uOMPost(body?: UOMCreateCommand, xRequestId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UOMDtoWebApiResponse>>;
    public uOMPost(body?: UOMCreateCommand, xRequestId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UOMDtoWebApiResponse>>;
    public uOMPost(body?: UOMCreateCommand, xRequestId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UOMDtoWebApiResponse>('post',`${this.basePath}/UOM`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uOMPut(body?: UOMUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<UOMDtoWebApiResponse>;
    public uOMPut(body?: UOMUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UOMDtoWebApiResponse>>;
    public uOMPut(body?: UOMUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UOMDtoWebApiResponse>>;
    public uOMPut(body?: UOMUpdateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UOMDtoWebApiResponse>('put',`${this.basePath}/UOM`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
